export const rolesCategory = [
	{
		name: 'Alarms',
		roles: [
			'activealarm',
			'historicalalarm',
			'alarmconfig',
			'alarmdampconfig',
		],		
	},
	{
		name: 'Firmware',
		roles: [
			'firmware',
			'schedulefirmware',
		],
	},
	{
		name: 'Reports',
		roles: ['alarmreport', 'kpireport', 'attackdetails'],
	},
	{
		name: 'Roles and Site(s)',
		roles: ['rolepermissiongroup', 'site', 'siteradioeirp'],
	},
	{
		name: 'Access Point(s)',
		roles: ['accesspoint', 'apcliuser', 'apradioeirp', 'tipradio', 'tipssid', 'rtty'],
	},
	// { name: 'Switches', roles: [] },
	{
		name: 'Switch(es)',
		roles: [
			'switch',
		],		
	},
	{
		name: 'License(s)',
		roles: ['licensedetails'],
	},
	{
		name: 'Global Profile(s)',
		roles: [
			'globalmacacl',
			'globalradiusserver',
			'globalssid',
			// 'globalssidtemplate',
			'ssidschedule',
			// 'l4l7identification',
			'eogreprofile',
			'acsschedule',
			'atfprofile',
			'natconfig',
			'multipsk',
			'vlanpooling',
			'rolebasedacl',
			'snmpconfiguration',
			'captiveportal',
		],
	},
	{
		name: 'Other',
		roles: [
			'myuser',
			'logentry',
			// 'eirpradioconfig',
			'tipprofile',
			// 'announce',
			'backuprestore',
			'packetcapture',
			// 'rebootfactoryreset',
			// 'troubleshooting',
			'notifications',
			// 'atpcconfiguration',
			// 'deviceprioritization',
			// 'openflow',
			// 'siteradio',
			'wipsconfig',
			// 'switch',
			// 'regulatorydomain',
			'systemconfig',
			'apsnapshot',
			'bulkaction',
			'floorplan',
		],
	},
];

export const categories = [
	{
		value: 'Read Only',
		label: 'Read Only',
	},
	{
		value: 'Admin',
		label: 'Admin',
	},
	{
		value: 'Previleged',
		label: 'Custom',
	},
];
export const rolesMapping = {
		activealarm:'Active Alarm',
		historicalalarm: 'Historical Alarm',
		alarmconfig: 'Alarm Config',
		alarmdampconfig: 'Alarm Damp Config',
		firmware: 'Firmware',
		firmwarestatus: 'Firmware Status',
		scheduledfirmwarepool: 'Scheduled Firmware Pool',
		schedulefirmware: 'Schedule Firmware',
		alarmreport: 'Alarm Report', 
		kpireport: 'KPI Report',
		rolepermissiongroup: 'Role Permission Group',
		accesspoint: 'Access Point', 
		apclients: 'AP Clients', 
		apcliuser: 'AP CLI User', 
		apssid: 'AP SSID',
		licenseapubrcount: 'License AP UBR Count', 
		licensedetails: 'License Details',
		license: 'License',
		globalmacacl: 'Global MAC ACL',
		globalssid:	'Global SSID',
		// globalssidtemplate:	'Global SSID Template',
		ssidschedule: 'SSID Schedule',
		// l4l7identification: 'L4 L7 Identification',
		myuser: 'My User',
		logentry: 'Audit Logs',
		apradioeirp: 'AP Radio EIRP',
		// eirpradioconfig: 'EIRP Radio Config',
		tipprofile: 'TIP Profile',
		tipradio: 'TIP Radio',
		rtty: 'RTTY Access',
		tipssid: 'TIP SSID',
		announce: 'Announce',
		backuprestore: 'Backup Restore',
		packetcapture: 'Packet Capture',
		// rebootfactoryreset: 'Reboot Factory Reset',
		// troubleshooting: 'Troubleshooting',
		notifications: 'Notifications',
		// atpcconfiguration: 'ATPC Configuration',
		attackdetails: 'WIDS/WIPS Report',
		captiveportal: 'Captive Portal',
		// deviceprioritization: 'Device Prioritization',
		eogreprofile: 'EoGRE Profile',
		multipsk: 'Multi PSK',
		openflow: 'Openflow',
		site: 'Site',
		// siteradio: 'Site Radio',
		siteradioeirp: 'Site Radio EIRP',
		vlanpooling: 'Vlan Pool',
		wipsconfig: 'WIDS/WIPS Config',
		acsschedule: 'ACS Schedule',
		atfprofile: 'ATF Profile',
		natconfig: 'NAT Config',
		switch: 'Switch',
		globalradiusserver:'AAA Server',
		// regulatorydomain: 'Regulatory Domain',
		systemconfig: 'System Config',
		apsnapshot: 'AP Snapshot',
		rolebasedacl: 'Role Based ACL',
		snmpconfiguration: 'SNMP Config',
		bulkaction: 'Bulk Action',
		floorplan: 'Floor Plan'
}

// dependency map for auto toggling of permissions based on other permissions
export const dependencyMap = {
	wipsconfig: ['attackdetails'],
	site: ['siteradioeirp'],
	schedulefirmware: ['scheduledfirmwarepool'],
	firmware: ['firmwarestatus'],
	accesspoint: ['apclients', 'apssid','apradioeirp'],
	licensedetails: ['license', 'licenseapubrcount', 'announce'],
	myuser: ['logentry'],
	alarmconfig: ['alarmdampconfig'],
	backuprestore: ['cnmssystembackuprestore'],
};
